"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.warningTriangle = exports.iconName = exports.paths = void 0;
exports.paths = [{ "tag": "path", "att": { "d": "M11.0036 14.2509h2v-6h-2v6zm1 1.5c-.6904 0-1.25.5596-1.25 1.25 0 .6903.5596 1.25 1.25 1.25.6903 0 1.25-.5597 1.25-1.25 0-.6904-.5597-1.25-1.25-1.25z" } }, { "tag": "path", "att": { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "m1.1152 20.5351 10-19h1.7699l10 19-.8849 1.4658h-20l-.885-1.4658zm2.5413-.5342h16.6873l-8.3436-15.853-8.3437 15.853z" } }];
exports.iconName = 'warning-triangle';
exports.warningTriangle = { iconName: exports.iconName, paths: exports.paths };
exports.default = exports.paths;
